import React from 'react';
import LeftRight from "../../components/ui/LeftRight";
import evokoMobileGif from "../../assets/images/products/pages/meeting-room/evoko-screenvideo.gif"
import m1 from "../../assets/images/products/pages/meeting-room/1.png"
import m2 from "../../assets/images/products/pages/meeting-room/2.png"
import m3 from "../../assets/images/products/pages/meeting-room/3.png";
import m4 from "../../assets/images/products/pages/meeting-room/4.png";
import m5 from "../../assets/images/products/pages/meeting-room/5.png";
import multipleImages from "../../assets/images/products/pages/meeting-room/multiple-images.png";
import {blackBox} from "../../constants/products/meetingRoom";
import SlideUp from "../../components/ui/SlideUp";
import {meetingRoomMeta} from "../../constants/meta";
import Meta from "../../components/common/Helmet";
import {useTranslation} from "react-i18next";


const MeetingRoomManagement = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Meta
        title={meetingRoomMeta.title}
        description={meetingRoomMeta.description}
        canonical={meetingRoomMeta.canonical}
        keywords={meetingRoomMeta.keywords}
        ogTitle={meetingRoomMeta.title}
        ogDescription={meetingRoomMeta.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto py-12 space-y-16">
        <LeftRight
          title={t('meetingRoomPage.title')}
          isLeft={true}
          textWidthClass={'md:w-1/2'}
          textPosition={'justify-center'}
          descriptionPosition={'text-center'}
          subtitle={t('meetingRoomPage.getRoomApp')}
          descriptionList={[
            t('meetingRoomPage.description')
          ]}
          icon={false}
          image={evokoMobileGif}
        />
        <LeftRight
          isLeft={false}
          textWidthClass={'md:w-3/5'}
          textPosition={'justify-start'}
          descriptionPosition={'text-left'}
          subtitle={t('meetingRoomPage.inTouchEfficiency')}
          descriptionList={[
            t('meetingRoomPage.itOnlyFinger')
          ]}
          icon={false}
          image={m1}
          downloadBtn={true}
          downloadLink={require("../../assets/uploads/pdf/meeting-room-management.pdf")}
        />
      </div>
      <div className="bg-slate-50">
        <div className="md:w-theme-container w-mobile-container mx-auto pt-16">
          <LeftRight
            title={t('meetingRoomPage.mainPoint')}
            isLeft={true}
            textPosition={'justify-center'}
            descriptionPosition={'text-left'}
            subtitle={t('meetingRoomPage.clarityIsKey')}
            descriptionList={[
              t('meetingRoomPage.aMeetingShould')
            ]}
            icon={true}
            image={m2}
          />
        </div>
      </div>
      <div className="md:w-theme-container w-mobile-container mx-auto py-16">
        <LeftRight
          isLeft={false}
          textPosition={'justify-center'}
          descriptionPosition={'text-left'}
          subtitle={t('meetingRoomPage.smoothScheduling')}
          descriptionList={[
            t('meetingRoomPage.itDoesNotMatter')
          ]}
          icon={true}
          image={m3}
        />
        <LeftRight
          isLeft={true}
          textPosition={'itext-left'}
          descriptionPosition={'text-left'}
          subtitle={t('meetingRoomPage.overviewScreen')}
          descriptionList={[
            t('meetingRoomPage.seeTheFull')
          ]}
          icon={true}
          image={m4}
        />
        <LeftRight
          isLeft={false}
          textPosition={'itext-left'}
          descriptionPosition={'text-left'}
          subtitle={t('meetingRoomPage.valuableStatistics')}
          descriptionList={[
            t('meetingRoomPage.statisticsDescription')
          ]}
          icon={true}
          image={m5}
        />
        <div className="multiple-images-section">
          <h2 className="text-center text-xl theme-font-bold md:text-2xl text-gray-900 uppercase mb-10">
            {t('meetingRoomPage.upAndRunning')}
          </h2>
          <div className="text-center text-gray-700 text-xl leading-relaxed ">
            {t('meetingRoomPage.evokoRoomManagerDescription')}
          </div>
          <div className="my-14">
            <img
              className="mx-auto"
              src={multipleImages}
              alt=""
            />
          </div>
        </div>
        <div className="black-box section md:mt-32 md:mb-36">
          <h2 className="text-center text-xl theme-font-bold md:text-2xl text-gray-900 uppercase mb-16">{t('meetingRoomPage.greatNess')}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {blackBox.map((item) => (
              <SlideUp key={item.id}>
                <div key={item.id} className="bg-gray-900 h-[350px] overflow-hidden text-white rounded-lg p-6 shadow-md">
                  <p className="text-xl uppercase mb-4">{t(`meetingRoomPage.${item.title}`)}</p>
                  <div className="space-y-4">
                    {item.description.map((desc, index) => (
                      <div key={index} className="flex items-start space-x-2">
                        <div className="text-blue-400 pt-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M12 0L15.09 7.36L23.64 8.64L17.5 14.14L19.27 22.64L12 18.27L4.73 22.64L6.5 14.14L0.36 8.64L8.91 7.36L12 0Z" />
                          </svg>
                        </div>
                        <p className={`text-white text-lg leading-relaxed text-left`}>
                          {t(`meetingRoomPage.${desc}`)}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </SlideUp>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingRoomManagement;
